import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { ExchangeAntimalwareScanTaskFormValue } from '../../../../../../utils/uiSettings/exchange/exchange-protection.types';
import { ExchangeAntimalwareScanTask } from '@nirvana/shared/dtos/types/policies/common';

// validate duplicates
export function validateDuplicates(
  ruleItem: ExchangeAntimalwareScanTaskFormValue,
  rulesInGrid: ExchangeAntimalwareScanTask[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some(
    (ruleInGrid: ExchangeAntimalwareScanTask) => ruleInGrid.name === ruleItem.name
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
